<script setup>
import { onMounted } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';

import WootReports from 'dashboard/routes/dashboard/settings/reports/components/WootReports.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const store = useStore();
const currentUser = useMapGetter('getCurrentUser');
onMounted(() => store.dispatch('agents/get'));
</script>

<template>
  <WootReports
    v-if="currentUser.id"
    :key="currentUser.id"
    type="agent"
    getter-key="agents/getAgents"
    action-key="agents/get"
    :selected-item="currentUser"
    :download-button-label="$t('AGENT_REPORTS.DOWNLOAD_AGENT_REPORTS')"
    :report-title="$t('AGENT_REPORTS.HEADER_HOME')"
    :show-filter-by-name="false"
    :show-download-button="false"
    :show-business-hours="false"
  />
  <div v-else class="w-full py-20">
    <Spinner class="mx-auto" />
  </div>
</template>
